import { UnfoldMore } from '@mui/icons-material'
import { Components, Theme } from '@mui/material'

export const MuiSelect: Components<Omit<Theme, 'components'>>['MuiSelect'] = {
  defaultProps: {
    displayEmpty: true,
    // TODO - new icon
    IconComponent: UnfoldMore,
    variant: 'standard',
    size: 'medium',
  },
  styleOverrides: {
    select: ({ theme, ownerState }) => {
      const hasValue = Array.isArray(ownerState.value)
        ? ownerState.value.length > 0
        : ownerState.value != null && ownerState.value !== ''
      return {
        color: hasValue ? theme.palette.text.default : theme.palette.text.subtle,
      }
    },
    icon: ({ theme }) => ({
      color: theme.palette.fg.muted,
      marginRight: theme.spacing(1.5),
    }),
    multiple: ({ theme }) => ({
      '& > .MuiStack-root': {
        gap: theme.spacing(1),
      },
    }),
  },
}
